export default __webpack_public_path__ + "static/media/Malaki_Portfolio_about.4226adec.jpg";